import React, { useEffect, useRef } from 'react'
import { Icon } from '@iconify/react'
import styles from './styles'
import { withStyles, Typography } from '@material-ui/core'
import { addSectionAction } from 'src/reducers/course/action'
import { useSelector, useDispatch } from 'react-redux'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import { messageBoxShowAction } from 'src/reducers/message-box/action'

import SectionNaming from './sectionNaming'
import clsx from 'clsx'
const AddSectionButton = props => {
  const { classes, sections, setSections, display = false } = props
  const editValueRef = useRef('')
  const dispatch = useDispatch()
  const open = useSelector(state => state.course.sectionDrawerOpen)
  const [sectionsExist, setSectionsExist] = React.useState(sections.length > 0)
  useEffect(() => {
    setSectionsExist(sections.length > 0)
  }, [sections])

  const addSection = () => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: 'Add Section',
          maxWidth: '500px',
          component: (
            <SectionNaming
              sections={sections}
              setSections={setSections}
              editValueRef={editValueRef}
            />
          ),
        }),
      ),
    )
  }
  return (
    <div
      className={clsx({
        [classes.container]: sectionsExist,
        [classes.containerWithoutSections]: !sectionsExist,
      })}
      onClick={addSection}
      style={{
        display: display !== true ? (open ? 'flex' : 'none') : 'flex',
      }}
    >
      <Icon icon="ci:add-row" />
      <Typography fontSize="13px" fontWeight={500}>
        Add Section
      </Typography>
    </div>
  )
}

export default withStyles(styles)(AddSectionButton)
